"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _AwaitingDeliveryProductOrder = _interopRequireDefault(require("../model/AwaitingDeliveryProductOrder"));

var _BackendIssue = _interopRequireDefault(require("../model/BackendIssue"));

var _CreateAwaitingDeliveryProductOrderRequest = _interopRequireDefault(require("../model/CreateAwaitingDeliveryProductOrderRequest"));

var _Forbidden = _interopRequireDefault(require("../model/Forbidden"));

var _InternalServerError = _interopRequireDefault(require("../model/InternalServerError"));

var _Unauthorized = _interopRequireDefault(require("../model/Unauthorized"));

var _ValidationError = _interopRequireDefault(require("../model/ValidationError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
* AwaitingDeliveryOrders service.
* @module api/AwaitingDeliveryOrdersApi
* @version 0.17
*/
var AwaitingDeliveryOrdersApi = /*#__PURE__*/function () {
  /**
  * Constructs a new AwaitingDeliveryOrdersApi. 
  * @alias module:api/AwaitingDeliveryOrdersApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function AwaitingDeliveryOrdersApi(apiClient) {
    _classCallCheck(this, AwaitingDeliveryOrdersApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Create Product Order
   * **Scopes**: - `awaiting-delivery-orders:write`  Add a new product to an existing purchase order which is waiting for delivery by a Kitchen Manager or Partner. For instance, in the case where a substitute for a product has been sent instead of the main product, we'll use this endpoint to add it to the current purchase order to create the substitute.
   * @param {String} purchaseUuid 
   * @param {module:model/CreateAwaitingDeliveryProductOrderRequest} createAwaitingDeliveryProductOrderRequest 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AwaitingDeliveryProductOrder} and HTTP response
   */


  _createClass(AwaitingDeliveryOrdersApi, [{
    key: "createProductOrderForAwaitingDeliveryOrderWithHttpInfo",
    value: function createProductOrderForAwaitingDeliveryOrderWithHttpInfo(purchaseUuid, createAwaitingDeliveryProductOrderRequest) {
      var postBody = createAwaitingDeliveryProductOrderRequest; // verify the required parameter 'purchaseUuid' is set

      if (purchaseUuid === undefined || purchaseUuid === null) {
        throw new Error("Missing the required parameter 'purchaseUuid' when calling createProductOrderForAwaitingDeliveryOrder");
      } // verify the required parameter 'createAwaitingDeliveryProductOrderRequest' is set


      if (createAwaitingDeliveryProductOrderRequest === undefined || createAwaitingDeliveryProductOrderRequest === null) {
        throw new Error("Missing the required parameter 'createAwaitingDeliveryProductOrderRequest' when calling createProductOrderForAwaitingDeliveryOrder");
      }

      var pathParams = {
        'purchase_uuid': purchaseUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AwaitingDeliveryProductOrder["default"];
      return this.apiClient.callApi('/awaiting-delivery-orders/{purchase_uuid}/products', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Create Product Order
     * **Scopes**: - `awaiting-delivery-orders:write`  Add a new product to an existing purchase order which is waiting for delivery by a Kitchen Manager or Partner. For instance, in the case where a substitute for a product has been sent instead of the main product, we'll use this endpoint to add it to the current purchase order to create the substitute.
     * @param {String} purchaseUuid 
     * @param {module:model/CreateAwaitingDeliveryProductOrderRequest} createAwaitingDeliveryProductOrderRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AwaitingDeliveryProductOrder}
     */

  }, {
    key: "createProductOrderForAwaitingDeliveryOrder",
    value: function createProductOrderForAwaitingDeliveryOrder(purchaseUuid, createAwaitingDeliveryProductOrderRequest) {
      return this.createProductOrderForAwaitingDeliveryOrderWithHttpInfo(purchaseUuid, createAwaitingDeliveryProductOrderRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return AwaitingDeliveryOrdersApi;
}();

exports["default"] = AwaitingDeliveryOrdersApi;